import { http } from '@/http/index'

async function muteNeurosexter(threadId) {
	return http.patch(`girl/${threadId}/mute-neurosexter`).then((response) => response.data)
}

export { muteNeurosexter }
